<template>
<div class="chapter">
<div class="inner_page">
<p class="indent-top">“<em class="italic">Taming CHAOS</em> is an excellent and appealing way for students and families to learn about risk and making good decisions.”</p>
<p class="right-para"><span class="bold">Sonia Levitin</span>, <em class="italic">Award Winning,</em> German American Novelist, Young Adult Author and Holocaust Survivor</p>
<p class="indent-top">“Gary Miller’s analysis of risk management is spot on. The book was written for teens, but it may interest college students too!”</p>
<p class="right-para"><span class="bold">M. Moshe Porat</span>, Ph.D., CPCU, Dean, Fox School of Business, Temple University</p>
<p class="indent-top">“Adolescence is the frontier during which children transition from dreamers to doers. Unlike adults; however, teens do not have the brain development necessary to create and stick to concrete decisions in their best interest. <em class="italic">Taming CHAOS</em> provides young adult readers with a prescriptive decision-making tool that is woven into the fabric of this delightful novel about decision-making and managing risk to adopt a rescued dog. <em class="italic">Taming CHAOS</em>: charming, age-appropriate, relevant for young teens who struggle with decision-making at the onset of carving out their unique path in life.”</p>
<p class="right-para"><span class="bold">Jeannie Hofmann</span>, English Teacher, <em class="italic">Teacher of the Year,</em> Upper Moreland High School, Montgomery County, PA</p>
<p class="indent-top">“As a current Middle School Principal and former High School Math Teacher, <em class="italic">Taming CHAOS</em> embraces all aspects of adolescent social, emotional, quantitative &amp; analytical development throughout its highly enjoyable story. All School Districts should adopt this excellent thought provoking book into their Character Education &amp; Math Curriculums!”</p>
<p class="right-para"><span class="bold">Adam Slavin</span>, Middle School Principal, Upper Merion Area School District, Montgomery County, PA</p>
<p class="indent-top">“A Groundbreaking and Revolutionary Masterpiece that will engage and inspire entire families.”</p>
<p class="right-para"><span class="bold">Michael Levin</span>, <em class="italic">New York Times</em> Best Selling Author</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?699952aa